import authCheck from "@/lib/auth";
import pageStyle from "../index.module.less";
import Title from "./components/title";
export default {
    name: "Group",
    data() {
        return { pageStyle };
    },
    components: { Title },
    props: {
        hide: Object,
        list: Array,
        onClick: Function
    },
    methods: {
        isHide(item) {
            const { id, permit, children = [] } = item;
            let allow = permit ? authCheck(permit) : true;
            childrenPermitCheck: {
                if (allow && children.length) {
                    // 如果父级有权限，且有子级
                    let ii = children.length;
                    while (ii--) {
                        if (!this.isHide(children[ii])) {
                            // 只要子级都是可以访问的，就可以访问
                            break childrenPermitCheck;
                        }
                    }
                    // 如果所有子级都没有权限，就不可访问
                    allow = false;
                }
            }
            return this.hide[id] || !allow;
        },
        isComponent(input = {}) {
            return !!input.render;
        }
    }
};
